/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Biosciences18Inputs */

const en__field__enum_additionalstudyinterests_study_biosciences18 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Biosciences18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biosciences`)
};

const de__field__enum_additionalstudyinterests_study_biosciences18 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Biosciences18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biowissenschaften`)
};

/**
* | output |
* | --- |
* | "Biosciences" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Biosciences18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_biosciences18 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Biosciences18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Biosciences18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_biosciences18(inputs)
	return de__field__enum_additionalstudyinterests_study_biosciences18(inputs)
});
export { _field__enum_additionalstudyinterests_study_biosciences18 as "_field__enum_additionalStudyInterests_STUDY_BIOSCIENCES" }